const careersJobFilter = [
    {
        selector: '[data-react="jobFilter"]',
        path: { filename: 'jobFilter' },
    },
];

export { careersJobFilter };
